import PropTypes from 'prop-types';
import React from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import { List, Record } from 'immutable';

import config from '../../../../config';

import CollectionStationsStore from '../../../../stores/CollectionStationsStore';
import connectToStores from '../../../../helpers/connectToStores';
import CollectionStationsActions from '../../../../actions/CollectionStationsActions';

import { translate as t } from '../../../../lib/I18n';
import FormattedHTMLMessage from '../../../general/FormattedHTMLMessage';
import ExternalLink from '../../../general/ExternalLink';
import ValidatedFormField from '../../../form/ValidatedField';

function _getStateFromStores () {
       return {
        collectionStations: CollectionStationsStore.get('stations'),
        isLoading: CollectionStationsStore.get('loading'),
    };
}

@connectToStores([ CollectionStationsStore ], _getStateFromStores)
class CollectionStation extends React.PureComponent {
    static propTypes = {
        isSubForm: PropTypes.bool,
        required: PropTypes.bool,
        isLoading: PropTypes.bool,
        collectionStations: PropTypes.instanceOf(List),
        visited: PropTypes.bool,
        validation: PropTypes.object,
        form: PropTypes.oneOfType([
            PropTypes.instanceOf(Record),
            PropTypes.object
        ]).isRequired,
        onChange: PropTypes.func.isRequired,
        disabled: PropTypes.bool,
        isKeyGo: PropTypes.bool
    };

    static defaultProps = {
        isLoading: false,
        collectionStations: new List(),
        isSubForm: false,
        required: false,
        visited: false,
        disabled: false,
        validation: {}
    };

    async componentDidMount () {
        await CollectionStationsActions.get();
    }

    render () {
        const { isKeyGo, isSubForm, form, onChange, disabled, visited, validation, collectionStations, required } = this.props;
        const Wrapper = isSubForm ? 'div' : 'form';
        const outsideLabelProp = isKeyGo ? { outsideLabel: true } : null;

        return (
            <Wrapper className="collection-location">
                <Row>
                    <Col xs={12}>
                        <ValidatedFormField
                            {...{form, onChange, disabled, visited, validation, required}}
                            type="select"
                            id="collectionLocation"
                            field="collectionLocation"
                            groupClassName="select-container margin-bottom--sm"
                            label={t('account.register.loadingStation.fieldLabel')}
                            placeholder={t('account.register.loadingStation.fieldLabel')}
                            labelClassName="sr-only"
                            {...outsideLabelProp}
                        >
                            <option value="">
                                {t('account.register.loadingStation.fieldPlaceholder')}
                            </option>
                            {collectionStations.map(station => (
                                <option key={station.nlc} value={station.nlc}>
                                    {station.get('name')}
                                </option>
                            ))}
                        </ValidatedFormField>
                    </Col>
                </Row>
                <p className={isKeyGo ? 'border--bottom margin-bottom padding-bottom--sm' : ''}>
                    {isKeyGo ? (
                        <FormattedHTMLMessage
                            className="text-size--normal text-weight--bold"
                            message="account.smartcard.keygo.loadingStation"
                            findMoreLink={
                                <ExternalLink
                                    message={ t('account.smartcard.keygo.loadingStation.findMore') }
                                    href={ config.get('keyGoInformationUrl') }
                                />
                            }
                        />
                    ) : (
                        t('account.register.loadingStation.fieldDescription')
                    )}
                </p>
            </Wrapper>
        );
    }
}


export default CollectionStation;



// WEBPACK FOOTER //
// ./src/components/account/smartcard/keyGoRegistration/CollectionStation.js